import React from 'react';
import { SOCIAL_LINKS } from '../../config/socials';
import FacebookBsIcon from '../../assets/icons/FacebookBsIcon';
import TikTokBsIcon from '../../assets/icons/TikTokBsIcon';
import InstagramBsIcon from '../../assets/icons/InstagramBsIcon';

const ICONS = [FacebookBsIcon, TikTokBsIcon, InstagramBsIcon];

const Footer: React.FC = () => (
  <footer className="text-center bg-secondary">
    <footer className="text-body bg-primary" data-bs-theme="dark">
      <div className="container py-4 py-lg-5">
        <div className="row justify-content-between">
          <div className="col-sm-4 col-md-3 text-center text-lg-start d-flex flex-column">
            <ul className="list-unstyled">
              <li>
                <a className="link-body-emphasis" href="terms-of-service">
                  Общи условия
                </a>
              </li>
              <li>
                <a className="link-body-emphasis" href="privacy-policy">
                  Политика за поверителност
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 d-flex flex-column align-items-center order-first order-lg-last">
            <div className="fw-bold d-flex align-items-center mb-2">
              <span>hristiyana-ivanova.com</span>
            </div>
            <p>ТАРО ЧЕТЕНЕ, КОЕТО ТИ ОТГОВАРЯ</p>
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-between align-items-center pt-3">
          <p className="mb-0">hristiyana-ivanova.com © 2026</p>
          <ul className="list-inline fs-5 mb-0">
            {SOCIAL_LINKS.map((link, i) => {
              const Icon = ICONS[i];
              return (
                <li key={link.label} className="list-inline-item">
                  <a href={link.href} aria-label={link.label} target="_blank" rel="noreferrer">
                    <Icon />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </footer>
  </footer>
);

export default Footer;
